import { useEffect, useRef } from 'react';
import { useAppSelector } from '../app/hooks';
import { SessionStatus } from '../redux/features/sessionBoundary/sessionBoundary.constants';
import {
  selectSessionEndReason,
  selectSessionStatus,
} from '../redux/features/sessionBoundary/sessionBoundary.selectors';
import {
  selectAllInvalidOptionLines,
  selectAllNotOnMenuCards,
} from '../redux/features/unresolvedItems/unresolvedItems.selector';
import logger from '../utils/logger';

/**
 * Emits a one-time session-summary log at session end recording how many
 * unresolved NOT_ON_MENU items and invalid-option lines the AI flagged this
 * session, for downstream analytics. Counts reflect everything the producer
 * shipped (cumulative), independent of which cards the agent dismissed.
 */
const useUnresolvedItemsSummary = () => {
  const sessionStatus = useAppSelector(selectSessionStatus);
  const sessionEndReason = useAppSelector(selectSessionEndReason);
  const notOnMenuCards = useAppSelector(selectAllNotOnMenuCards);
  const invalidOptionLines = useAppSelector(selectAllInvalidOptionLines);
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (sessionStatus === SessionStatus.end) {
      if (!hasLoggedRef.current) {
        hasLoggedRef.current = true;
        logger.log({
          message: 'unresolved_items_session_summary',
          sessionEndReason,
          notOnMenuCount: notOnMenuCards.length,
          invalidOptionCount: invalidOptionLines.length,
        });
      }
    } else {
      // Reset so the next session logs its own summary.
      hasLoggedRef.current = false;
    }
  }, [sessionStatus, sessionEndReason, notOnMenuCards, invalidOptionLines]);
};

export default useUnresolvedItemsSummary;
